import type { SVGProps } from "react";
import { memo } from "react";
const CommandLineInterface = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#2E27AD" />
        <stop offset="100%" stopColor="#527FFF" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M12 13v54h34v-2H14V23h52v42h-7v2h9V13zm2 8h52v-6H14zm11-2h2.001v-2.001H25zm-4 0h2v-2.001h-2zm-4 0h2v-2.001h-2zm6.326 14.432 10.08 10.082-10.08 10.08 1.414 1.414 11.494-11.494L24.74 32.018zM38 51h17v-2H38z"
      />
    </g>
  </svg>
);
const Memo = memo(CommandLineInterface);
export default Memo;
